import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "position", "up", "down"];

  connect() { this.refresh(); }

  move(event) {
    const item = event.currentTarget.closest("li");
    if (event.params.direction === "up" && item.previousElementSibling) {
      item.parentElement.insertBefore(item, item.previousElementSibling);
    } else if (event.params.direction === "down" && item.nextElementSibling) {
      item.parentElement.insertBefore(item.nextElementSibling, item);
    }
    this.refresh();
  }

  refresh() {
    this.itemTargets.forEach((item, index) => {
      item.querySelector('[data-work-sequence-target="position"]').textContent = index + 1;
      item.querySelector('[data-work-sequence-target="up"]').disabled = index === 0;
      item.querySelector('[data-work-sequence-target="down"]').disabled = index === this.itemTargets.length - 1;
    });
  }
}
